"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.heroVideoSwitch = void 0;
/* ========================================================================
    Module: Hero video
 ========================================================================== */
const util_1 = require("~modules/util");
const breakPointLarge = (0, util_1.getCssPropertyValue)("--uk-breakpoint-l");
/**
 * 再生する動画をメディアクエリで切り替える
 *
 * @returns void
 */
const heroVideoSwitch = () => {
    const homeHeroVideo = document.querySelector(".js-home-hero-video");
    if (!homeHeroVideo) {
        return;
    }
    let baseUrl = homeHeroVideo.dataset.baseUrl || "/";
    if (baseUrl.slice(-1) !== "/") {
        baseUrl += "/";
    }
    const homeHeroVideoSource = homeHeroVideo.querySelector(":scope > source");
    let switchSource = baseUrl + "movie-sp.mp4";
    if (window.matchMedia(`(min-width: ${breakPointLarge})`).matches) {
        switchSource = baseUrl + "movie.mp4";
    }
    homeHeroVideo.innerHTML = `<source src="${switchSource}">`;
    // 元のファイル名と違う場合のみリロードする
    if (homeHeroVideoSource &&
        sourceFilename(homeHeroVideoSource.src) !== sourceFilename(switchSource)) {
        homeHeroVideo.load();
        homeHeroVideo.play();
    }
};
exports.heroVideoSwitch = heroVideoSwitch;
/**
 * ファイルパスからファイル名を取得する
 *
 * @param path string|null
 * @returns string
 */
const sourceFilename = (path) => {
    const filename = path?.split("/").pop();
    return filename || "";
};
